import { render } from "./ReferView.vue?vue&type=template&id=0e427681"
import script from "./ReferView.vue?vue&type=script&lang=js"
export * from "./ReferView.vue?vue&type=script&lang=js"

import "./ReferView.vue?vue&type=style&index=0&id=0e427681&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__